function Footer() {
  return (
    <footer className="footer">
      <p>&#169; {new Date().getFullYear()} Mesto Russia</p>
    </footer>
  );
}

export default Footer;
